function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "home-icon");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M522.46,582.15h-145a17.24,17.24,0,0,1-17.24-17.23V439.08h-96V564.92A17.24,17.24,0,0,1,247,582.15H102a17.24,17.24,0,0,1-17.24-17.23v-262H17.24a17.23,17.23,0,0,1-11.6-30l295-268.4a17.21,17.21,0,0,1,23.19,0l295,268.4a17.23,17.23,0,0,1-11.59,30H539.69v262A17.24,17.24,0,0,1,522.46,582.15ZM394.71,547.68H505.22v-262a17.24,17.24,0,0,1,17.24-17.24h40.22L312.24,40.54,61.79,268.4H102a17.24,17.24,0,0,1,17.23,17.24v262H229.76V421.84A17.24,17.24,0,0,1,247,404.61H377.48a17.24,17.24,0,0,1,17.23,17.23Z"
})));

var SvgHomeIcon = function SvgHomeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 624.47 582.15",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHomeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home-icon.57cbef1e.svg";
export { ForwardRef as ReactComponent };